<app-home-menu
  class="block absolute w-full"
  [menus]="menus()"
  [showMenu]="isHome"
  [isSmall]="isSmallMenu"
  [isFixed]="isFixedMenu"
  [isAni]="isAni"
/>
